import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetHealthDateAuthorizationParams,
	GetHealthDateAuthorization,
	GetHealthDateAuthorizationModel,
} from 'domain/usecases';
import {APIError} from 'data/errors/api-error';

export class RemoteGetHealthDateAuthorization implements GetHealthDateAuthorization {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetHealthDateAuthorizationModel>,
	) {}

	async get(params: GetHealthDateAuthorizationParams): Promise<GetHealthDateAuthorizationModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
